import { Injectable } from '@angular/core'

import { BankConsentLog } from '@lemon/core-firebase/model/banks'
import { HolviOauthConnectRequest, HolviOauthConnectResponse } from '@lemon/core-firebase/model/holvi'
import { BankConsentUriService } from '@lemon/core-firebase/service/bank-consent-uri.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { Timestamp } from 'firebase/firestore'
import { FirebaseLemonaid } from './firebase-lemonaid.service'

@Injectable()
export class HolviDialogService {
  private _holviFlowCompletedAt: Date = null
  private _postponeStarted: Date = null

  constructor(
    private _timestampService: TimestampService,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _bankConsentUriService: BankConsentUriService,
  ) {}

  setFlowCompleted() {
    this._holviFlowCompletedAt = new Date()
  }

  flowCompletedRecently(): boolean {
    if (!this._holviFlowCompletedAt) {
      return false
    }
    const oneHourInMilliseconds = 60 * 60 * 1000
    return new Date().getTime() - this._holviFlowCompletedAt.getTime() < oneHourInMilliseconds
  }

  postpone() {
    this._postponeStarted = new Date()
  }

  postponedRecently(): boolean {
    if (!this._postponeStarted) {
      return false
    }
    const oneHourInMilliseconds = 60 * 60 * 1000
    return new Date().getTime() - this._postponeStarted.getTime() < oneHourInMilliseconds
  }

  async fetchHolviOauthStartUrl(asiakasAvain: string) {
    const data: HolviOauthConnectRequest = {}

    const resp = await this._firebaseLemonaid.functionsCall<HolviOauthConnectRequest, HolviOauthConnectResponse>('holviOauthConnectStart', data)
    if (!resp || resp.e) {
      // await this.saveHistory(asiakasAvain, 'failed', resp?.e ?? null)
      throw new Error(resp ? resp.e : 'unknown-error')
    }
    // await this.saveHistory(asiakasAvain, 'success', null)
    return resp.redirectUrl
  }

  saveHistory(asiakasAvain: string, changedReason: string, details: string) {
    const logData: BankConsentLog = {
      asiakasAvain: asiakasAvain,
      source: 'holvi',
      changedTime: Timestamp.now(),
      changedReason: changedReason,
      details: details ?? null,
    }
    const avain = this._firebaseLemonaid.firestoreCreateId()
    const uri = this._bankConsentUriService.getBankConsentLogUri(asiakasAvain, avain)

    return this._firebaseLemonaid.firestoreSetData(uri, logData)
  }
}
